export const isMultipleRowGroupingColumnMode = (showGroupedColumns: boolean | undefined) => {
  return showGroupedColumns === true;
};
